<script setup lang="ts">
import { declineWords } from '~/shared/utils/declineWords';

const props = defineProps<{
  title: string;
  subtitle?: string;
  results?: number;
  showBorderBottom: boolean;
}>();
</script>

<template>
  <div
    :class="[
      $style.page__header,
      { [$style.page__header_showBorderBottom!]: showBorderBottom },
    ]"
  >
    <div :class="$style.page__header__top">
      <ButtonBack :class="$style.article__info__back" />
      <div v-if="props.results" :class="$style.page__header_results">
        {{ props.results }}
        {{
          declineWords(props.results, [
            'Результат',
            'Результата',
            'Результатов',
          ])
        }}
      </div>
    </div>
    <div :class="$style.page__header_titleRow">
      <div :class="$style.page__header_title">{{ props.title }}</div>
      <slot name="title-aside" />
    </div>
    <div
      v-if="props.subtitle"
      :class="$style.page__header_subtitle"
      v-html="props.subtitle"
    ></div>
  </div>
</template>

<style module lang="scss">
.page__header {
  padding: var(--space-2-5x);

  &__top {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--space-2-5x);
  }

  &__back {
    @include text_caption1_caps;
    color: var(--color-gray-text);
    display: flex;
    gap: 5px;
    align-items: center;
    text-decoration: none;
  }

  &_icon {
    path {
      fill: var(--color-gray-text);
    }
  }

  &_showBorderBottom {
    border-bottom: 1px solid var(--color-gray-line);
  }

  &_results {
    @include text_caption1_caps;
    color: var(--color-gray-text);
    text-transform: uppercase;
  }

  &_titleRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-2x);
  }

  &_title {
    font-weight: 600;
    font-size: 40px;
    line-height: 110%;
    color: var(--color-black-1);
  }

  &_subtitle {
    @include text_body2;
    margin-top: var(--space-1x);
    color: var(--color-black-1);
  }
}

@media (max-width: 767px) {
  .page__header {
    &_titleRow {
      flex-direction: column;
      align-items: flex-start;
      gap: var(--space-1x);
    }
  }
}

@media (max-width: 479px) {
  .page__header {
    padding: 16px;

    &_title {
      @include text_h4;
    }
  }
}
</style>
